export const DeviceIndexSceneTranslation = {
  fi: {
    DeviceIndexScene: {
      title: 'Älylääkekaapit',
      create: 'Yhdistä uusi',
      emptyText: 'Voit yhdistää uuden älylääkekaapin sivun oikeasta ylälaidasta.',
    },
  },
};
